import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { phoneValidation } from "validationSchemas/common";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import { showSuccess, showError } from "toast/toast";
import { useNavigate, useParams, Link } from "react-router-dom";
import Select, { SingleValue, components } from "react-select";
import { AsyncPaginate, LoadOptions } from "react-select-async-paginate";
import { StatusBadge } from "components/Productlocationstatus";
import { Addresses } from "types";
import InstallationStatusTracker from "components/InstallationStatusTracker";
import AddressFormModal from "components/AddAddressFormModal";
import SectionHeader from "components/SectionPillPropsIcons";
import InstructionsCreateCard from "components/Notes";
import ProductSelection from "assets/images/brands/ProductSelection.png"
import Doller from "assets/images/brands/doller.png"
import OrderNotes from "assets/images/brands/OrderNotes.png"
import SpecialFeeui from "components/Tax/InstallationandremovalSpecialfeeui";
import PONumber from "components/PONumber";
import { OrderDiscountCodeField } from "components/orderResolve";
import {
    applyRemovalWorkOrderResolveResponse,
    buildRemovalResolvePayload,
    getOrderDiscountFieldDisplay,
    mapInstallationSpecialFeeForResolve,
    mapInstallationSpecialFeeForSubmit,
    mapSavedInstallationSpecialFeeToUi,
    normalizeInstallationSelectedFee,
    overlayRemovalSubmitFromResolved,
    postRemovalOrderResolve,
    type InstallationResolveAddress,
    type ResolvedRemovalOrder,
} from "orderResolve";
import { handleApiError } from "utils/errorHandler";
import { safeConsole, createSafeNavigate } from "utils/envUtils";
import { buildSpecialFeeCostBreakdownDisplay } from "utils/specialFeeCostBreakdownDisplay";
// const mapContainerStyle = {
//     width: "100%",
//     height: "400px",
// };
import { getAuthCookie } from "../../utils/authCookies";
// import { sendRemovalOrderTriggerEmail } from "utils/salesOrderTriggerEmailEngine";
import {
    buildRemovalDynamicCostAddressBody,
    buildRemovalAddressOptions,
    createRemovalOrder,
    mergeRemovalOrderBillingAddress,
    postRemovalDynamicCost,
    removalOrderUrls,
    resolveRemovalAddressMembershipId,
    resolveRemovalSellerOrganizationId,
    resolveRemovalSpecialFeePersonId,
    resolveRemovalSubmitBillingAddress,
    buildRemovalInstallerPayloadFields,
    resolveRemovalInstallerMembershipId,
    resolveRemovalInstallerName,
} from "api/removalApi";
import { fetchUserAddresses, searchCompletedInstallationOrders } from "api/installationApi";
import { removalPartyIdentityFromSavedOrder } from "utils/removalPartyIdentity";

const mapContainerStyle = {
    width: "100%",
    height: "350px",
    borderRadius: "12px",
    overflow: "hidden",
    // boxShadow: "0 0 10px rgba(0,0,0,0.1)", // Soft shadow
    // border: "1px solid #dee2e6",          // Light border
};

const center = {
    lat: 40.712776, // Default latitude (e.g., New York City)
    lng: -74.005974, // Default longitude
};

/** Show a readable label for generated custom-product SKUs. */
function displayRemovalSku(item: { sku?: string; custom_sku?: string; inventory_source?: string }): string {
    if (String(item.inventory_source) !== "custom") return String(item.sku ?? "");

    const customSku = String(item.custom_sku ?? item.sku ?? "").trim();
    if (!customSku) return "";

    if (/^custom_sku(?:_|$)/i.test(customSku)) {
        return "Custom SKU";
    }

    return customSku;
}

type Selected = {
    value: string;
    label: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}

const DropdownIndicator = (props: any) => {
    return (
        <components.DropdownIndicator {...props}>
            <i className="ri-arrow-down-s-line fs-5" style={{ color: '#6c757d' }}></i>
        </components.DropdownIndicator>
    );
};

// Custom styles to ensure dropdown indicator is always visible
const customSelectStyles = {
    dropdownIndicator: (provided: any, state: any) => ({
        ...provided,
        display: 'flex !important',
        opacity: 1,
        visibility: 'visible',
    }),
    indicatorSeparator: (provided: any, state: any) => ({
        ...provided,
        display: 'none',
    }),
};
const AgentAddRemovalRequest = () => {
    const { id } = useParams(); // get ID from URL
    const token = getAuthCookie("sessionToken");
    const userId = getAuthCookie("userId");
    const membershipId = getAuthCookie("membershipId");
    const userName = getAuthCookie("userName");
    const licenseType = getAuthCookie("licenseType");

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>("");
    const [preview, setPreview] = useState<string | null>(null);
    const [formSubmitting, setFormSubmitting] = useState(false);
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const [quantity, setQuantity] = useState(1);
    const [addressObjects, setAddressObjects] = useState<any[]>([]);
    const [showAllocateModal, setShowAllocateModal] = useState(false);
    const [removalOrder, setRemovalOrder] = useState<any>(null);
    const [products, setProducts] = useState<any>(null);
    const [installer, setInstaller] = useState<any[]>([]);
    const [selectedInstaller, setSelectedInstaller] = useState<Selected | null>(null);
    const [previewFiles, setPreviewFiles] = useState<{ file: File; url: string }[]>([]);
    const [uploadedFileMeta, setUploadedFileMeta] = useState<any[]>([]);
    const [removalQuantities, setRemovalQuantities] = useState<Record<string, number>>({});
    const [removalCost, setRemovalCost] = useState<number | null>(null);
    const [selectedBillingAddress, setSelectedBillingAddress] = useState<Addresses | null>(null);
    const [installationAddress, setInstallationAddress] = useState<Addresses>();
    const [complietInstallationOrders, setComplietInstallationOrders] = useState<any[]>([]);
    const [instructions, setInstructions] = useState<string>("");
    const [showAddressForm, setShowAddressForm] = useState(false);
    const [removalTrackingSummary, setRemovalTrackingSummary] = useState<any>(null);

    // ✅ State for special fees (bypasses Formik timing issues)
    const [selectedSpecialFees, setSelectedSpecialFees] = useState<any[]>([]);
    const [allAvailableSpecialFees, setAllAvailableSpecialFees] = useState<any[]>([]);
    const [isRecomputing, setIsRecomputing] = useState(false);

    // State for banner below widget
    const [zeroOrNegativeMsg, setZeroOrNegativeMsg] = React.useState<string>("");
    const [couponInput, setCouponInput] = React.useState("");
    const [liveDiscountDisplay, setLiveDiscountDisplay] = React.useState({ code: "", amount: 0 });
    const lastResolvedRemovalRef = React.useRef<ResolvedRemovalOrder | null>(null);
    const userClearedCouponRef = React.useRef(false);
    const isUpdatingFromRecomputeRef = React.useRef(false);
    const lastRecomputeParamsRef = React.useRef("");
    const recomputeRequestIdRef = React.useRef(0);
    const pendingRecomputeRef = React.useRef(false);
    const [dynamicCostId, setDynamicCostId] = React.useState<string>("");
    const [dynamicTaxable, setDynamicTaxable] = React.useState<boolean>(false);
    const [showTaxDetails, setShowTaxDetails] = useState(false);

        // Select2 API configuration
        const PAGE_SIZE = 10;

    const [selectedLocation, setSelectedLocation] = useState<{
        lat: number;
        lng: number;
    } | null>(null);
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string, // Replace with your API key
    });

    const navigate = useNavigate();
    const safeNavigate = createSafeNavigate(navigate);
    useEffect(() => {
        return () => {
            if (preview) URL.revokeObjectURL(preview);
        };
    }, [preview]);

    const addressOptions = useMemo(
        () => buildRemovalAddressOptions(addressObjects, removalOrder?.billing_address),
        [addressObjects, removalOrder?.billing_address]
    );

    const complietInstallationOrdersOptions = complietInstallationOrders?.map(order => ({
        value: order._id,
        label: order.order_number,
    }));
    const [selectedInstallationOption, setSelectedInstallationOption] = useState<{ value: string; label: string } | null>(null);

    const loadCompletedInstallationOrderOptions: LoadOptions<{ value: string; label: string }, any, { page: number }> = useCallback(
        async (inputValue, _loadedOptions, additional) => {
            const page = additional?.page ?? 1;
            const searchEntityId = String(membershipId || "").trim();
            if (!searchEntityId || !token) {
                return { options: [], hasMore: false, additional: { page } };
            }
            const q: string = (inputValue || "").trim();
            try {
                const params = new URLSearchParams({
                    q: q,
                    page: String(page),
                    limit: String(PAGE_SIZE),
                });
                const data = await searchCompletedInstallationOrders(
                    token,
                    searchEntityId,
                    params.toString()
                );
                const list = data?.results ?? data?.orders ?? data?.data ?? [];
                const options = (Array.isArray(list) ? list : []).map((o: any) => ({
                    value: o.id ?? o._id ?? "",
                    label: o.text ?? o.order_number ?? o.label ?? String(o.id ?? o._id ?? ""),
                }));
                const hasMore = typeof data?.pagination?.more === "boolean"
                    ? !!data.pagination.more
                    : data?.totalPages
                        ? page < (data.totalPages || 1)
                        : data?.total
                            ? page * (data?.limit ?? PAGE_SIZE) < data.total
                            : options.length === PAGE_SIZE;
                return { options, hasMore, additional: { page: page + 1 } };
            } catch (err) {
                await handleApiError(err, {
                    module: "removal",
                    action: "Agent_Add_Removal_Request_load_completed_installation_order_options",
                    userId: userId || undefined,
                    licenseType: licenseType || undefined,
                    userName: userName || undefined,
                    url: `${process.env.REACT_APP_API_URL}/installation_orders/search/${searchEntityId}`,
                    method: "GET",
                    additionalInfo: { page, q, membershipId: searchEntityId },
                }, token);
                return { options: [], hasMore: false, additional: { page } };
            }
        },
        [token, PAGE_SIZE, membershipId, userId, licenseType, userName]
    );

    // Fetch removal tracking summary
    const fetchRemovalTrackingSummary = async (orderId: string) => {
        if (!orderId) {
            safeConsole.log("No installation order number available yet");
            return;
        }
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/removal_tracking/installation_order/${orderId}/summary`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const data = await response.json();

            if (!response.ok) {
                safeConsole.error("Failed to fetch removal tracking summary:", data.error);
                return;
            }

            setRemovalTrackingSummary(data);
            safeConsole.log("Fetched removal tracking summary:", data);
        } catch (err) {
            await handleApiError(err, {
                module: "removal",
                action: "Agent_Add_Removal_Request_fetch_removal_tracking_summary",
                userId: userId || undefined,
                licenseType: licenseType || undefined,
                userName: userName || undefined,
                url: `${process.env.REACT_APP_API_URL}/removal_tracking/installation_order/${orderId}/summary`,
                method: "GET",
                additionalInfo: { orderId },
            }, token);
        }
    };

    // Helper function to get already removed quantity for a product
    const getAlreadyRemovedQuantity = (productId: string) => {
        if (!removalTrackingSummary) return 0;
        const summaryItem = removalTrackingSummary.find((item: any) =>
            item.key === productId && item.inventory_source !== "rotational"
        );
        return summaryItem ? summaryItem.total_removed : 0;
    };

    // Helper function to calculate available quantity for display
    const getAvailableQuantity = (item: any) => {
        const alreadyRemoved = getAlreadyRemovedQuantity(item.product_id);
        return Math.max(0, item.quantity - alreadyRemoved);
    };

    // const fetchComplietInstallationOrders = async () => {
    //     try {
    //         const response = await fetch(
    //             `${process.env.REACT_APP_API_URL}/installation_orders/search/${userId}`,
    //             {
    //                 method: "GET",
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                     "Content-Type": "application/json",
    //                 },
    //             }
    //         );
    //         const data = await response.json();
    //         safeConsole.log("Complite Installation Orders :", data);
    //         setComplietInstallationOrders(data.orders);
    //     } catch (err) {
    //         setError(
    //             err instanceof Error ? err.message : "An unknown error occurred"
    //         );
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // useEffect(() => {
    //     fetchComplietInstallationOrders();
    // }, [token]);

    const fetchRemovalOrder = async (orderId: string | undefined) => {
        if (!orderId) return;
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/installation_orders/${orderId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data?.error || "Failed to fetch removal order");
            }
            safeConsole.log("Fetched installation Order:", data);
            setRemovalOrder(data);
            setProducts(data.line_items || []);

            // Initialize quantities after summary is loaded
            const initializeQuantities = async () => {
                await fetchRemovalTrackingSummary(data._id);

                const initialQuantities: Record<string, number> = {};
                data.line_items?.forEach((item: any) => {
                    if (item.inventory_source !== "rotational") {
                        // Only include products that have available quantity > 0
                        const alreadyRemoved = getAlreadyRemovedQuantity(item.product_id);
                        const availableQuantity = Math.max(0, item.quantity - alreadyRemoved);
                        if (availableQuantity > 0) {
                            initialQuantities[item.product_id] = 0; // default quantity
                        }
                    }
                });
                setRemovalQuantities(initialQuantities);
            };

            initializeQuantities();
        } catch (error: any) {
            await handleApiError(error, {
                module: "removal",
                action: "Agent_Add_Removal_Request_fetch_removal_order",
                userId: userId || undefined,
                licenseType: licenseType || undefined,
                userName: userName || undefined,
                url: `${process.env.REACT_APP_API_URL}/installation_orders/${orderId}`,
                method: "GET",
                additionalInfo: { orderId },
            }, token);
        } finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        fetchRemovalOrder(id);
    }, [id]);

    useEffect(() => {
        const fetchAddresses = async () => {
            const routeMembershipId =
                resolveRemovalAddressMembershipId(removalOrder) || userId || "";
            if (!routeMembershipId || !token) return;
            try {
                const data = await fetchUserAddresses(token, routeMembershipId);
                const rows = Array.isArray(data) ? data : [];
                setAddressObjects(
                    mergeRemovalOrderBillingAddress(rows, removalOrder?.billing_address)
                );
            } catch (err) {
                await handleApiError(err, {
                    module: "removal",
                    action: "Agent_Add_Removal_Request_fetch_addresses",
                    userId: userId || undefined,
                    licenseType: licenseType || undefined,
                    userName: userName || undefined,
                    url: `${process.env.REACT_APP_API_URL}/organization-memberships/${routeMembershipId}/addresses`,
                    method: "GET",
                }, token);
                setError(
                    err instanceof Error ? err.message : "An unknown error occurred"
                );
            } finally {
                setLoading(false);
            }
        };

        if (removalOrder || userId) {
            void fetchAddresses();
        }
    }, [token, userId, licenseType, userName, removalOrder]);

    // defult removal address set
    useEffect(() => {
        if (removalOrder) {
            const addr = removalOrder?.installation_details?.installation_address;
            setInstallationAddress(addr);
        }
        if (removalOrder?.billing_address) {
            setSelectedBillingAddress(removalOrder.billing_address);
            setAddressObjects((prev) =>
                mergeRemovalOrderBillingAddress(prev, removalOrder.billing_address)
            );
        }

    }, [removalOrder]);

    // seting defult location state to show the poiner in map
    useEffect(() => {
        if (
            installationAddress?.address_details?.latitude &&
            installationAddress?.address_details?.longitude &&
            installationAddress?.address_details?.latitude !== 0 &&
            installationAddress?.address_details?.longitude !== 0
        ) {
            setSelectedLocation({
                lat: installationAddress?.address_details?.latitude,
                lng: installationAddress?.address_details?.longitude,
            });
        }
    }, [installationAddress]);

    useEffect(() => {
        const fetchRemovalCost = async () => {
            if (
                !installationAddress?.address_details?.latitude ||
                !installationAddress?.address_details?.longitude ||
                installationAddress?.address_details?.latitude === 0 ||
                installationAddress?.address_details?.longitude === 0
            ) {
                showError(
                    "Selected removal address is missing latitude/longitude. Please enter the address manually."
                );
                return;
            }

            const sellerOrgId = resolveRemovalSellerOrganizationId(
                removalOrder?.signage_id,
                removalOrder
            );
            const removalCostPayload = buildRemovalDynamicCostAddressBody(
                installationAddress?.address_details
            );

            try {
                const data = await postRemovalDynamicCost(token, sellerOrgId, removalCostPayload);
                safeConsole.log("Removal cost:", data);
                setDynamicCostId(data.id);
                setDynamicTaxable(data.is_taxable || data.taxable);
                setRemovalCost(data.cost || 0);
            } catch (error: any) {
                await handleApiError(error, {
                    module: "removal",
                    action: "Agent_Add_Removal_Request_fetch_removal_cost",
                    userId: userId || undefined,
                    licenseType: licenseType || undefined,
                    userName: userName || undefined,
                    url: `${process.env.REACT_APP_API_URL}${removalOrderUrls.dynamicCost(sellerOrgId)}`,
                    method: "POST",
                    requestBody: removalCostPayload,
                }, token);
                safeConsole.error("Cost fetch error:", error.message);
                setRemovalCost(null);
            }
        };

        if (installationAddress) {
            fetchRemovalCost();
        }
    }, [installationAddress, removalOrder, token, userId, licenseType, userName]);

    const DEFAULT_TEN_ZEROS = "0000000000";
    const withDefault = (v?: string, def = DEFAULT_TEN_ZEROS) =>
        !v || v.trim() === "" || v === def ? def : v;

    const removalSpecialFeePersonId = useMemo(
        () => resolveRemovalSpecialFeePersonId(removalOrder, { sessionMembershipId: userId }),
        [removalOrder, userId]
    );
    const removalSpecialFeeSupplierId = useMemo(
        () =>
            resolveRemovalSellerOrganizationId(removalOrder?.signage_id, removalOrder) ||
            String(removalOrder?.seller_owner_node_id ?? removalOrder?.signage_id ?? "").trim(),
        [removalOrder]
    );

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            userType: removalOrder?.user_type,
            userFirstName: removalOrder?.agent_name?.split(' ')[0] || "",
            userLastName: removalOrder?.agent_name?.split(' ').slice(1).join(' ') || "",
            userEmail: removalOrder?.user_email,
            userPhone: removalOrder?.user_phone,
            brokerageFirmsId: removalOrder?.brokerage_firm_id,
            brokerage_firm_admin: removalOrder?.brokerage_firm_admin,
            teamMemberId: removalOrder?.team_member_id,
            office: removalOrder?.office,
            inventorySource: removalOrder?.inventory_source,
            order_number: removalOrder?.order_number,
            priority: "",
            removal_date: "",
            assignedId: "",
            agentId: removalOrder?.agent_id,
            agent: removalOrder?.agent_name,
            // officeId: removalOrder?.office?._id,
            removal_quantity: 0,
            billing_address: removalOrder?.billing_address,
            removal_address: removalOrder?.installation_details.installation_address,
            isSameAsBilling: !!removalOrder?.both_address_same,
            billingAddressId: removalOrder?.billing_address?._id,
            removalAddressId: removalOrder?.installation_details?.installation_address?._id,
            location: "",
            installation_order: removalOrder?._id || "",
            products: "",
            instructions: instructions,
            payment_method: "",
            po_number: "",
            image: null,
            localLawsChecked: false,
            subtotal: 0,
            total: removalOrder?.total_amount,
            tax: 0,
            discount: 0,
            discount_amount: 0,
            discount_code: "",
            gatecode: "",
            label_of_address: "",
            firstName: "",
            lastName: "",
            phone: DEFAULT_TEN_ZEROS || "",
            addressLine1: "",
            addressLine2: "",
            city: "",
            state: "",
            zipcode: "",
            country: "",
            company: "",
            removal_cost: 0,
            removal_taxable: true,
            removal_tax_percentage: null,
            calc_removal_rate_str: "",
            calc_overall_rate_str: "",
            calc_fee_rate_str: "",
            destination: { addressLine1: "", city: "", state: "", zip: "", country: "US", stateCode: "", countryCode: "US" },
            specialfee: [] as Array<{
                id: string;
                name: string;
                amount: number;
                taxable?: boolean;
                tax_percentage?: number | null;
            }>,
            totals: { removal_subtotal: 0, removal_tax_amount: 0, specialfee_subtotal: 0, specialfee_tax_amount: 0, grand_total: 0, cartId: "", specialfee_id: [], specialfee_name: [] },
        },
        validationSchema: Yup.object({
            removal_date: Yup.string().required("Removal date is required"),
            // installation_order: Yup.string()
            //     .required("Installation job order is required"),

            // ✅ Required dropdown for Removal Priority
            priority: Yup.string()
                .required("Removal priority is required"),

            // ✅ Billing address required
            billingAddressId: Yup.string()
                .required("Billing address is required"),
            removalAddressId: Yup.string()
                .required("Removal address is required"),

            // ✅ Agent name, email, and phone validation
            agent: Yup.string().required("Agent name is required"),
            userEmail: Yup.string()
                .email("Invalid email format")
                .required("Email is required"),
            userPhone: phoneValidation,
            // installer: Yup.string().required("Installer is required"),
            // installation_date: Yup.string().required("Installation date is required"),
            // billing_address: Yup.string().required("Billing address is required"),
            // installation_address: Yup.string().required(
            //     "Installation address is required"
            // ),
            // image: Yup.mixed().required("Image is required"),
        }),
        onSubmit: async (values) => {
            // ✅ Validate required special fees BEFORE submission
            const requiredFees = allAvailableSpecialFees.filter((f: any) => f.required === true);
            const selectedFeeIds = selectedSpecialFees.map((f: any) => String(f.id));
            const missingRequiredFees = requiredFees.filter((f: any) => !selectedFeeIds.includes(String(f.id || f._id)));
            if (
                !UNIQUE_ID_KEY1 ||
                UNIQUE_ID_KEY1 === "000000000000000000000000"
            ) {
                showError("UNIQUE_ID_KEY1 is missing or zeros. Please try again.");
                return; // stop further code
            }


            if (missingRequiredFees.length > 0) {
                const feeNames = missingRequiredFees.map((f: any) => f.name).join(", ");
                showError(`The following required special fees must be selected: ${feeNames}`);
                return; // Don't submit
            }

            setFormSubmitting(true);
            let removalOrderPayload: any;
            try {
                const resolveOk = await recompute({ force: true });
                if (!resolveOk || !lastResolvedRemovalRef.current) {
                    showError("Pricing could not be calculated. Please try again.");
                    setFormSubmitting(false);
                    return;
                }

                const resolved = lastResolvedRemovalRef.current;
                const uiFees = selectedSpecialFees || [];
                const feeRows = uiFees.map((f) =>
                    mapInstallationSpecialFeeForSubmit(f, { catalog: allAvailableSpecialFees })
                );
                const billingAddress = resolveRemovalSubmitBillingAddress({
                    billingAddressId: values.billingAddressId,
                    inventorySource: removalOrder?.inventory_source,
                    addressObjects,
                    selectedBillingAddress,
                    orderBillingAddress: removalOrder?.billing_address,
                    formBillingAddress: values.billing_address,
                });

                // Example file upload handling
                const imageUrl = values.image ? await uploadFile(values.image) : null;
                const cleanedLineItems = products?.map((item: any) => {
                    const toRemove = removalQuantities[item.product_id] || 0;

                    // Find all serial allocations for this product from rotational items
                    let serial_allocations = [];
                    if (item.inventory_source !== "rotational") {
                        // For a normal product, find all serials where source_product_id === item.product_id in *all* products
                        serial_allocations = products?.filter((p: any) => p.inventory_source === "rotational" && Array.isArray(p.serial_allocations))?.flatMap((p: any) =>
                            p.serial_allocations?.filter((s: any) => s.source_product_id === item.product_id)?.map((s: any) => ({
                                bin_id: s.bin_id,
                                rack_id: s.rack_id,
                                serial_id: s.serial_id,
                                serial_code: s.serial_code,
                                warehouse_id: s.warehouse_id,
                                status: s.status,
                                zone_id: s.zone_id,
                                warehouse_name: s.warehouse_name,
                                zone_name: s.zone_name,
                                rack_name: s.rack_name,
                                bin_name: s.bin_name,
                            }))
                        );
                    } else if (Array.isArray(item.serial_allocations)) {
                        // For rotational products themselves (if you want to send them), include their own serials
                        serial_allocations = item.serial_allocations?.map((s: any) => ({
                            bin_id: s.bin_id,
                            rack_id: s.rack_id,
                            serial_id: s.serial_id,
                            serial_code: s.serial_code,
                            warehouse_id: s.warehouse_id,
                            status: s.status,
                            zone_id: s.zone_id,
                            warehouse_name: s.warehouse_name,
                            zone_name: s.zone_name,
                            rack_name: s.rack_name,
                            bin_name: s.bin_name,
                        }));
                    }

                    return {
                        product_id: item.product_id,
                        variant_id: item.variant_id || "",
                        product_name: item.product_name,
                        inventory_source: item.inventory_source,
                        rotational_allocated: item.rotational_allocated,
                        source_product_id: item.inventory_source === "rotational" ? item.serial_allocations[0].source_product_id : item.product_id,
                        sku: item.sku,
                        available_quantity: item.quantity - toRemove,
                        quantity_to_be_removed: toRemove,
                        restock_quantity: 0,
                        writeoff_quantity: 0,
                        reason_to_writeoff: "",
                        current_status: item.current_status,
                        unit_price: item.unit_price,
                        total_price: item.total_price,
                        discount: item.discount || 0,
                        tax_amount: item.tax_amount || 0,
                        is_rotational: item.is_rotational,
                        notes: [
                            {
                                value: values.instructions,
                                added_by: {
                                    id: userId,
                                    name: userName,
                                },
                                added_at: new Date().toISOString(),
                            },
                        ],
                        storage_locations: item.storage_locations || [],
                        serial_allocations,
                    };
                });

                removalOrderPayload = {
                    user_type: values.userType,
                    user_email: values.userEmail,
                    user_name: removalOrder?.agent_name || (values.userFirstName + " " + values.userLastName).trim() || "",
                    user_phone: values.userPhone,
                    order_number: null, // or generate dynamically
                    status: 100,
                    installation_order_id: removalOrder?._id,
                    installation_order_number: removalOrder?.order_number,
                    inventory_source: removalOrder?.inventory_source,
                    source_id: removalOrder?.source_id,
                    brokerage_firm_id: removalOrder?.brokerage_firm_id || null,
                    brokerage_firm_name: removalOrder?.brokerage_firm_name || null,
                    brokerage_firm_admin: removalOrder?.brokerage_firm_admin || null,
                    team_member_id: removalOrder?.team_member_id || null,
                    team_member_name: removalOrder?.team_member_name || null,
                    office: removalOrder?.office || null,
                    agent_id: values.agentId || null,
                    agent_name: removalOrder?.agent_name || null,
                    signage_id: resolveRemovalSellerOrganizationId(
                        removalOrder?.signage_id,
                        removalOrder
                    ),
                    signage_company_name: removalOrder?.signage_company_name,
                    ...removalPartyIdentityFromSavedOrder(removalOrder),
                    line_items: cleanedLineItems,
                    customer_group_id: null,
                    payment_method: "",
                    tax_status: "draft",
                    payment_status: "Pending",
                    po_number: String(values.po_number || "").trim(),
                    payment_info: [], // or provide details
                    gate_access_code: values.gatecode || "",
                    removal_details: {
                        scheduled_date: new Date(values.removal_date).toISOString(),
                        removal_address: removalOrder?.installation_details.installation_address,
                        ...buildRemovalInstallerPayloadFields(removalOrder, selectedInstaller, {
                            contactNumber: removalOrder?.installation_details?.contact_number,
                        }),
                        estimated_duration: null,
                        actual_removal_date: null,
                        additional_instructions: [
                            {
                                value: values.instructions,
                                added_by: {
                                    id: userId,
                                    name: userName,
                                },
                                added_at: new Date().toISOString(),
                            },
                        ],
                        tax_details: null,
                    },
                    billing_address: billingAddress,
                    both_address_same: values.isSameAsBilling,
                    additional_instructions: [
                        {
                            value: values.instructions,
                            added_by: {
                                id: userId,
                                name: userName,
                            },
                            added_at: new Date().toISOString(),
                        },
                    ],
                    local_laws_compliance: values.localLawsChecked,
                    priority: Number(values.priority),
                    uploaded_files: uploadedFileMeta || [],
                    subtotal_amount: Number(resolved.subtotal_amount ?? 0),
                    removal_cost: Number(resolved.removal_cost ?? removalCost ?? 0),
                    specialfee: feeRows,
                    additional_cost: Number(resolved.additional_cost ?? 0),
                    discount_amount: Number(resolved.discount_amount ?? 0),
                    discount_code: String(resolved.discount_code ?? ""),
                    total_amount: Number(resolved.total_amount ?? 0),
                    removal_tax_amount: Number(resolved.removal_tax_amount ?? 0),
                    removal_tax_percentage: resolved.removal_tax_percentage ?? undefined,
                    over_all_tax_amount: Number(resolved.over_all_tax_amount ?? 0),
                    over_all_tax_percentage: resolved.over_all_tax_percentage ?? "",
                    tax_amount: 0,
                    overpaid_amount: 0,
                    version: 1,
                    tax_inclusive: false,
                    tax_details: null,
                    cart_id: resolved.cart_id || UNIQUE_ID_KEY1 || undefined,
                };

                removalOrderPayload = overlayRemovalSubmitFromResolved(
                    removalOrderPayload,
                    lastResolvedRemovalRef.current
                );

                const response = await createRemovalOrder(token, removalOrderPayload);
                const data = await response.json();
                if (!response.ok) {
                    const userEmailError = data?.userEmail;
                    const userPhoneError = data?.userPhone;

                    if (userEmailError) {
                        formik.setFieldError("userEmail", userEmailError);
                        formik.setFieldTouched("userEmail", true, false);
                    }

                    if (userPhoneError) {
                        formik.setFieldError("userPhone", userPhoneError);
                        formik.setFieldTouched("userPhone", true, false);
                    }

                    if (userEmailError || userPhoneError) {
                        return;
                    }

                    throw new Error(data?.error || data?.message || "Failed to create removal order");
                }

                localStorage.removeItem("re_agent_removal_unique_id")

                // ✅ Trigger 1: Agent Removal Request Created - Send notifications
                try {
                  const { createNotification } = await import("../../services/notificationApi");
                  const { getAgentRemovalRequestCreatedContent } = await import("../../services/notificationContent");
                  const { fetchRemovalMembershipContact } = await import("../../api/removalApi");
                  
                  const orderNumber = data?.order_number || data.order_id;
                  const agentName = removalOrder?.agent_name || values.userFirstName + " " + values.userLastName || userName || "Agent";
                  
                  // Notify Agent
                  if (userId && token) {
                    const agentContent = getAgentRemovalRequestCreatedContent({
                      orderId: orderNumber,
                      agentName,
                      recipientType: "agent",
                    });
                    await createNotification(userId, agentContent, token, "agent");
                  }

                  // Notify Selected Installer (Signage Admin/Team Member) only
                  const installerMembershipId = selectedInstaller?.value;
                  if (installerMembershipId && token) {
                    try {
                      const supplierData = await fetchRemovalMembershipContact(token, installerMembershipId);
                      const supplierLicenseType = supplierData?.licenseType || "SIGNAGE_FIRM";
                      const supplierRecipientType = supplierLicenseType === "SIGNAGE_FIRM" ? "signage_admin" : "team_member";

                      const signageContent = getAgentRemovalRequestCreatedContent({
                        orderId: orderNumber,
                        agentName,
                        recipientType: supplierRecipientType,
                      });
                      await createNotification(installerMembershipId, signageContent, token, supplierRecipientType);
                    } catch (err) {
                      safeConsole.warn(`Failed to send notification to selected installer ${installerMembershipId}:`, err);
                    }
                  }
                } catch (notifError) {
                  safeConsole.warn("Failed to send removal request created notification:", notifError);
                  // Don't block the order creation if notification fails
                }

                // Email moved to backend (removal_order_email_service)
                // Send email notifications for removal request created
                // const from = process.env.REACT_APP_FROM_EMAIL2 || "noreply@realesy.com";
                // if (from && data.order_id) {
                    // try {
                        // Fetch created removal order data
                        // let orderData: any;
                        // try {
                            // const orderResponse = await fetch(
                                // `${process.env.REACT_APP_API_URL}/removal_orders/${data.order_id}`,
                                // {
                                    // method: "GET",
                                    // headers: {
                                        // Authorization: `Bearer ${token}`,
                                        // "Content-Type": "application/json",
                                    // },
                                // }
                            // );
                            
                            // if (orderResponse.ok) {
                                // orderData = await orderResponse.json();
                            // } else {
                                // throw new Error("Failed to fetch order for email");
                            // }
                        // } catch (orderFetchError) {
                            // await handleApiError(orderFetchError, {
                                // module: "removal",
                                // action: "Agent_Add_Removal_Request_fetch_order_for_email",
                                // userId: userId || undefined,
                                // licenseType: licenseType || undefined,
                                // userName: userName || undefined,
                                // url: `${process.env.REACT_APP_API_URL}/removal_orders/${data.order_id}`,
                                // method: "GET",
                            // }, token);
                            // throw orderFetchError;
                        // }
                        
                        // if (orderData) {
                            // await sendRemovalOrderTriggerEmail({
                                // triggerName: "Agent Removal Request Created",
                                // removalOrderId: String(orderData?._id || data?.order_id || ""),
                                // token: token || "",
                                // fromEmail: from,
                                // includeOrderPdfAttachment: true,
                            // });
                        // }
                    // } catch (emailError) {
                        // safeConsole.error("Failed to send removal request created emails:", emailError);
                        // Don't block navigation if email fails
                    // }
                // }

                safeNavigate(`/agent/jobs/viewRemovalRequest/${data.order_id}`, { state: { type: "View" } });
                showSuccess("Removal request created successfully!");
            } catch (error: any) {
                await handleApiError(error, {
                    module: "removal",
                    action: "Agent_Add_Removal_Request_create_removal_order",
                    userId: userId || undefined,
                    licenseType: licenseType || undefined,
                    userName: userName || undefined,
                    url: `${process.env.REACT_APP_API_URL}/removal_orders`,
                    method: "POST",
                    requestBody: removalOrderPayload,
                }, token);
                safeConsole.error(error);
                showError(`Error: ${error.message}`);
            } finally {
                setFormSubmitting(false);
                setUploadProgress(0);
            }
        },
    });

    useEffect(() => {
        const addressDetails = installationAddress?.address_details;
        if (!addressDetails) return;

        const removalAddressValue =
            installationAddress?._id ||
            [
                addressDetails.addressLine1,
                addressDetails.city,
                addressDetails.state,
                addressDetails.zip,
            ]
                .filter(Boolean)
                .join(", ");

        if (!removalAddressValue) return;

        formik.setFieldValue("removalAddressId", removalAddressValue, false);
    }, [installationAddress]);


    const UNIQUE_ID_KEY = "re_agent_removal_unique_id";
    const UNIQUE_ID_KEY1 = localStorage.getItem("re_agent_removal_unique_id");


    async function ensureDraftUniqueId(token?: string): Promise<string | null> {
        try {
            // 1) if already cached, return it
            const existing = localStorage.getItem(UNIQUE_ID_KEY);
            if (existing) return existing;

            if (!token) return null;

            // 2) else fetch one from API and cache it
            const res = await fetch(`${process.env.REACT_APP_API_URL}/utils/new-unique-id`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            if (!res.ok) return null;

            const data = await res.json().catch(() => ({}));
            const id = data.id || data?.data?.id || data?.data?.unique_id || data?.unique_id || null;
            if (!id) return null;

            localStorage.setItem(UNIQUE_ID_KEY, id);
            return id;
        } catch (error) {
            await handleApiError(error, {
                module: "removal",
                action: "Agent_Add_Removal_Request_ensure_draft_unique_id",
                userId: userId || undefined,
                licenseType: licenseType || undefined,
                userName: userName || undefined,
                url: `${process.env.REACT_APP_API_URL}/utils/new-unique-id`,
                method: "GET",
            }, token);
            return null;
        }
    }

    // ✅ Call ensureDraftUniqueId when buyer type is set (from removalOrder or programmatically)
    React.useEffect(() => {
        const currentType = formik.values.userType;
        if (!currentType || !token) return;

        const ensureId = async () => {
            try {
                const id = await ensureDraftUniqueId(token || "");
                if (id) {
                    formik.setFieldValue("draft_unique_id", id, false);
                }
            } catch (err) {
                safeConsole.error("Error ensuring draft unique ID:", err);
            }
        };

        ensureId();
    }, [formik.values.userType, token]);



    // ✅ Use useMemo to compute derived values instead of useEffect to prevent cascading updates
    const computedTotals = React.useMemo(() => {
        const t = formik.values.totals || {};
        const subAll = Number(t.removal_subtotal || 0) + Number(t.specialfee_subtotal || 0);
        const taxAll = Number(t.removal_tax_amount || 0) + Number(t.specialfee_tax_amount || 0);
        const grand = Number(t.grand_total || 0);
        const final = Math.max(0, grand - Number(formik.values.discount_amount || 0));

        return { subtotal: subAll, tax: taxAll, total: final, grand };
    }, [
        formik.values.totals?.removal_subtotal,
        formik.values.totals?.specialfee_subtotal,
        formik.values.totals?.removal_tax_amount,
        formik.values.totals?.specialfee_tax_amount,
        formik.values.totals?.grand_total,
        formik.values.discount_amount,
    ]);

    // ✅ Only update formik when computed values actually change (prevents infinite loops)
    const prevComputedTotalsRef = React.useRef(computedTotals);
    React.useEffect(() => {
        const prev = prevComputedTotalsRef.current;
        if (
            prev.subtotal !== computedTotals.subtotal ||
            prev.tax !== computedTotals.tax ||
            prev.total !== computedTotals.total
        ) {
            formik.setFieldValue("subtotal", computedTotals.subtotal, false);
            formik.setFieldValue("tax", computedTotals.tax, false);
            formik.setFieldValue("total", computedTotals.total, false);
            prevComputedTotalsRef.current = computedTotals;
        }
    }, [computedTotals]);

    const specialFeeSubtotalDisplay = React.useMemo(
        () => selectedSpecialFees.reduce((total, fee) => total + Number(fee?.amount || 0), 0),
        [selectedSpecialFees]
    );
    const removalCostDisplay = Number(removalCost ?? 0);
    const removalTaxAmountDisplay = Number(formik.values.totals?.removal_tax_amount ?? 0);
    const specialFeeTaxAmountDisplay = Number(formik.values.totals?.specialfee_tax_amount ?? 0);
    const combinedTaxDisplay = removalTaxAmountDisplay + specialFeeTaxAmountDisplay;
    const subtotalDisplay = Number(
        formik.values.subtotal ?? removalCostDisplay + specialFeeSubtotalDisplay
    );
    const discountAmountDisplay = Number(formik.values.discount_amount ?? 0);
    const totalAmountDisplay = Number(
        formik.values.total ??
        Math.max(0, removalCostDisplay + specialFeeSubtotalDisplay + combinedTaxDisplay - discountAmountDisplay)
    );

    const effectiveCouponCreatedById = React.useMemo(
        () => String(removalOrder?.agent_id || userId || ""),
        [removalOrder?.agent_id, userId]
    );

    const formikValuesRef = React.useRef(formik.values);
    React.useEffect(() => {
        formikValuesRef.current = formik.values;
    }, [formik.values]);

    const getSelectedFees = React.useCallback(() => {
        return selectedSpecialFees
            .map((f) => normalizeInstallationSelectedFee(f, allAvailableSpecialFees))
            .filter((f) => f.id !== "");
    }, [selectedSpecialFees, allAvailableSpecialFees]);

    const debounceRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
    const isRecomputingRef = React.useRef(false);

    type RecomputeOverride = { fees?: any[]; discountCode?: string; force?: boolean };

    const recompute = React.useCallback(async (override?: RecomputeOverride) => {
        if (!dynamicCostId || !token) return false;
        if (isRecomputingRef.current && !override?.force) return false;

        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
            debounceRef.current = null;
        }

        const fees = override?.fees ?? getSelectedFees();
        const allFeesSubtotal = fees.reduce((sum: number, f: any) => sum + Number(f.amount || 0), 0);
        const discountCode =
            override?.discountCode !== undefined
                ? String(override.discountCode).trim()
                : String(
                      userClearedCouponRef.current
                          ? ""
                          : formikValuesRef.current.discount_code || couponInput
                  ).trim();

        const addr = installationAddress?.address_details;
        const requestSignature = JSON.stringify({
            dynamicCostId,
            removalCost: Number(removalCost) || 0,
            dynamicTaxable,
            discountCode,
            feeSig: fees.map((f: any) => `${f.id}:${Number(f.amount || 0)}`).sort().join(","),
            addressSig: addr
                ? `${addr.addressLine1}-${addr.city}-${addr.state}-${addr.zip}`
                : "",
        });

        if (!override?.force && lastRecomputeParamsRef.current === requestSignature) {
            return true;
        }

        recomputeRequestIdRef.current += 1;
        const currentRequestId = recomputeRequestIdRef.current;
        lastRecomputeParamsRef.current = requestSignature;

        isRecomputingRef.current = true;
        setIsRecomputing(true);
        try {
            if (currentRequestId !== recomputeRequestIdRef.current) return false;

            const sellerOrgId = resolveRemovalSellerOrganizationId(
                removalOrder?.signage_id,
                removalOrder
            );
            const billingAddress = resolveRemovalSubmitBillingAddress({
                billingAddressId: formikValuesRef.current.billingAddressId,
                inventorySource: removalOrder?.inventory_source,
                addressObjects,
                selectedBillingAddress,
                orderBillingAddress: removalOrder?.billing_address,
                formBillingAddress: formikValuesRef.current.billing_address,
            });
            const resolvePayload = buildRemovalResolvePayload({
                cartId: String(UNIQUE_ID_KEY1 || formik.values.totals?.cartId || ""),
                dynamicCostId,
                signageId: sellerOrgId,
                sourceId: String(removalOrder?.source_id || userId || ""),
                customerId: String(effectiveCouponCreatedById || userId || ""),
                inventorySource: String(removalOrder?.inventory_source || "agent"),
                removalCost: Number(removalCost) || 0,
                removalTaxable: dynamicTaxable,
                discountCode,
                paymentMethod: formikValuesRef.current.payment_method || "card",
                userType: formikValuesRef.current.userType,
                userName: `${formikValuesRef.current.userFirstName || ""} ${formikValuesRef.current.userLastName || ""}`.trim() || userName || "",
                userEmail: formikValuesRef.current.userEmail,
                userPhone: formikValuesRef.current.userPhone,
                agentId: userId || removalOrder?.agent_id || null,
                agentName: removalOrder?.agent_name || userName || null,
                billingAddress: billingAddress as InstallationResolveAddress | null,
                removalAddress: installationAddress as InstallationResolveAddress | null,
                installerId: resolveRemovalInstallerMembershipId(removalOrder, selectedInstaller),
                installerName: resolveRemovalInstallerName(removalOrder, selectedInstaller),
                lineItems: [],
                specialFees: fees.map((f: any) => mapInstallationSpecialFeeForResolve(f, allAvailableSpecialFees)),
                partyIdentity: removalPartyIdentityFromSavedOrder(removalOrder),
            });

            const resolved = await postRemovalOrderResolve(token, {
                order_type: "removal",
                action: "draft",
                payload: resolvePayload,
            });

            if (currentRequestId !== recomputeRequestIdRef.current) return false;

            if (!resolved || typeof resolved !== "object") {
                formik.setFieldValue("totals.removal_subtotal", Number(removalCost) || 0, false);
                formik.setFieldValue("totals.removal_tax_amount", 0, false);
                formik.setFieldValue("totals.specialfee_subtotal", allFeesSubtotal, false);
                formik.setFieldValue("totals.specialfee_tax_amount", 0, false);
                formik.setFieldValue("totals.grand_total", (Number(removalCost) || 0) + allFeesSubtotal, false);
                formik.setFieldValue("specialfee", fees, false);
                return false;
            }

            lastResolvedRemovalRef.current = resolved;
            isUpdatingFromRecomputeRef.current = true;
            const applied = applyRemovalWorkOrderResolveResponse(
                resolved,
                formik,
                Number(removalCost) || 0,
                {
                    requestedDiscountCode: discountCode,
                    existingFeeRows: fees,
                    specialFeeCatalog: allAvailableSpecialFees,
                }
            );
            setSelectedSpecialFees(applied.mergedFees);
            formik.setFieldValue("specialfee", applied.mergedFees, false);
            setLiveDiscountDisplay(
                getOrderDiscountFieldDisplay({
                    formikCode: formikValuesRef.current.discount_code,
                    formikAmount: formikValuesRef.current.discount_amount,
                    couponInput,
                    resolved: resolved as Parameters<typeof getOrderDiscountFieldDisplay>[0]["resolved"],
                })
            );
            if (discountCode) {
                setCouponInput(discountCode);
            } else if (!formikValuesRef.current.discount_code) {
                setCouponInput("");
            }
            return true;
        } catch (e) {
            safeConsole.error("[OrderResolve] agent removal add failed:", e);
            return false;
        } finally {
            isRecomputingRef.current = false;
            setIsRecomputing(false);
            if (pendingRecomputeRef.current) {
                pendingRecomputeRef.current = false;
                setTimeout(() => {
                    void recompute({ force: true });
                }, 0);
            }
        }
    }, [
        token,
        userId,
        userName,
        dynamicCostId,
        removalCost,
        dynamicTaxable,
        couponInput,
        removalOrder,
        selectedBillingAddress,
        installationAddress,
        effectiveCouponCreatedById,
        UNIQUE_ID_KEY1,
        formik,
        getSelectedFees,
    ]);


    // const recompute = React.useCallback(async () => {
    //     // if (!dynamicCostId) return;

    //     // ✅ Prevent overlapping recompute calls
    //     if (isRecomputingRef.current) {
    //         safeConsole.log("⏭️ Skipping recompute - already in progress");
    //         return;
    //     }

    //     isRecomputingRef.current = true;
    //     setIsRecomputing(true);
    //     try {
    //         const dest = coalesceDestination();
    //         // ✅ Use selectedSpecialFees directly to avoid closure issues
    //         const fees = selectedSpecialFees.map(f => ({
    //             id: String(f?.id ?? ""),
    //             name: String(f?.name ?? "Special Fee"),
    //             amount: Number(f?.amount ?? 0),
    //             taxable: f?.taxable !== false,
    //             tax_percentage: f?.tax_percentage ?? null,
    //             tax_amount: f?.tax_amount ?? null,
    //             tax_rule_id: f?.tax_rule_id ?? null,
    //             tax_group_id: f?.tax_group_id ?? null,
    //         })).filter(f => f.id !== "");
    //         safeConsole.log("recompute - fees from selectedSpecialFees:", fees);

    //         const removalPrice = Number(removalCost ?? 0);
    //         const discount = Number(formik.values.discount_amount || 0);
    //         const discountedBase = Math.max(0, removalPrice - discount);
    //         // ✅ Build products using the SAME fees that will be passed to tax engine
    //         const products = buildProductsMerged(fees);

    //         const totals = await runTaxEngineForInstallations({
    //             token: token || "",
    //             supplierId: supplierId,
    //             ownerId: userId || "",
    //             roleType: "agent",
    //             cartId: UNIQUE_ID_KEY1 || "",
    //             products,
    //             mode: "create",
    //             destination: dest,
    //             installation: {
    //                 dynamic_cost_id: dynamicCostId,
    //                 installation_cost: discountedBase || 0,
    //                 taxable: dynamicTaxable,
    //                 tax_percentage: formik.values.removal_tax_percentage ?? null,
    //                 job_types: ["removal"],
    //             },
    //             specialFees: fees,
    //         });

    //         safeConsole.log("[TaxEngine] totals:", totals);

    //     // ✅ WRITE engine totals into Formik (source of truth for the UI)
    //     formik.setFieldValue("totals.removal_subtotal", Number(totals.installation_subtotal || 0), false);
    //     formik.setFieldValue("totals.removal_tax_amount", Number(totals.installation_tax_amount || 0), false);

    //     // ✅ Calculate special fee subtotal from ALL selected fees (taxable + non-taxable)
    //     const allFeesSubtotal = fees.reduce((sum, f) => sum + Number(f.amount || 0), 0);
    //     formik.setFieldValue("totals.specialfee_subtotal", allFeesSubtotal, false);

    //     formik.setFieldValue("totals.specialfee_tax_amount", Number(totals.specialfee_tax_amount || 0), false);
    //     formik.setFieldValue("totals.grand_total", Number(totals.grand_total || 0), false);

    //     // ✅ Merge enriched taxable fees from engine with non-taxable fees
    //     const enrichedTaxableFees = Array.isArray(totals.specialfee) ? totals.specialfee : [];

    //     // Create a map of enriched fees by ID
    //     const enrichedById = new Map(
    //         enrichedTaxableFees.map((f: any) => [String(f.id), f])
    //     );

    //     // Merge: use enriched data for taxable fees, keep original for non-taxable
    //     const mergedFees = fees.map((f: any) => {
    //         const enriched = enrichedById.get(String(f.id));
    //         if (enriched) {
    //             // Taxable fee - use enriched data from engine
    //             return {
    //                 id: String(enriched.id || ""),
    //                 name: String(enriched.name || ""),
    //                 amount: Number(enriched.amount || 0),
    //                 taxable: enriched.taxable !== false,
    //                 tax_percentage: enriched.tax_percentage ?? null,
    //                 tax_amount: Number(enriched.tax_amount || 0),  // ✅ Tax amount from engine
    //                 tax_rule_id: enriched.tax_rule_id ?? null,
    //                 tax_group_id: enriched.tax_group_id ?? null,
    //             };
    //         } else {
    //             // Non-taxable fee - keep original with tax_amount = 0
    //             return {
    //                 id: String(f.id || ""),
    //                 name: String(f.name || ""),
    //                 amount: Number(f.amount || 0),
    //                 taxable: f.taxable !== false,
    //                 tax_percentage: null,
    //                 tax_amount: 0,  // ✅ No tax for non-taxable fees
    //                 tax_rule_id: f.tax_rule_id ?? null,
    //                 tax_group_id: f.tax_group_id ?? null,
    //             };
    //         }
    //     });

    //     formik.setFieldValue("specialfee", mergedFees, false);
    //     setSelectedSpecialFees(mergedFees);
    //     safeConsole.log("✅ Merged special fees (taxable + non-taxable):", mergedFees);

    //     const subTotalAll = Number(totals.installation_subtotal) + Number(totals.specialfee_subtotal);
    //     const taxAll = Number(totals.installation_tax_amount) + Number(totals.specialfee_tax_amount);

    //     // Optional: get %s from first matching tax lines (strings for backend)
    //     const removalRateStr = (() => {
    //         const ln = (totals.taxLines || []).find(l => l.itemType === "InstallationCost");
    //         return typeof ln?.rate === "number" ? String(ln.rate) : "";
    //     })();
    //     const feeRateStr = (() => {
    //         const ln = (totals.taxLines || []).find(l => l.itemType === "SpecialFee");
    //         return typeof ln?.rate === "number" ? String(ln.rate) : "";
    //     })();
    //     const overallRateStr = subTotalAll > 0 ? String(taxAll / subTotalAll) : "";

    //     formik.setFieldValue("tax", taxAll, false);
    //     formik.setFieldValue("calc_removal_rate_str", removalRateStr, false);
    //     formik.setFieldValue("calc_fee_rate_str", feeRateStr, false);
    //     formik.setFieldValue("calc_overall_rate_str", overallRateStr, false);

    //     if ((totals as any).cartId) {
    //         formik.setFieldValue("totals.cartId", String((totals as any).cartId), false);
    //     }

    // } catch (e) {
    //     safeConsole.error("[TaxEngine] failed:", e);
    // } finally {
    //     isRecomputingRef.current = false;
    //     setIsRecomputing(false);
    // }
    // }, [
    //     token,
    //     userId,
    //     removalOrder?.signage_id,
    //     removalCost,
    //     dynamicCostId,
    //     dynamicTaxable,
    //     formik.values.removal_taxable,
    //     formik.values.removal_tax_percentage,
    //     formik.values.discount_amount,
    //     installationAddress?.address_details?.addressLine1,
    //     installationAddress?.address_details?.city,
    //     installationAddress?.address_details?.state,
    //     installationAddress?.address_details?.stateCode,
    //     installationAddress?.address_details?.zip,
    //     JSON.stringify(selectedSpecialFees),  // ✅ Watch actual fee content
    // ]);

    const ready = React.useMemo(
        () =>
            Boolean(
                removalOrder?.signage_id &&
                installationAddress?.address_details &&
                !Number.isNaN(removalCost)
            ),
        [removalOrder?.signage_id, installationAddress?.address_details, removalCost]
    );

    // ---- Debounced trigger (runs only when ready) ----------------------
    const recomputeRef = React.useRef(recompute);
    React.useEffect(() => {
        recomputeRef.current = recompute;
    }, [recompute]);

    const triggerRecomputeIfReady = React.useCallback(() => {
        if (!ready) return;

        if (isRecomputingRef.current) {
            pendingRecomputeRef.current = true;
            return;
        }

        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            if (!isRecomputingRef.current) {
                recomputeRef.current();
            }
        }, 300);
    }, [ready]);

    React.useEffect(() => {
        return () => { if (debounceRef.current) clearTimeout(debounceRef.current); };
    }, []);

    // ✅ Combine duplicate useEffects into one to prevent multiple re-renders
    // Create stable dependency tracking using useMemo
    const addressKey = React.useMemo(() => {
        const addr = installationAddress?.address_details;
        if (!addr) return '';
        return `${addr.addressLine1}-${addr.city}-${addr.state}-${addr.stateCode}-${addr.zip}`;
    }, [
        installationAddress?.address_details?.addressLine1,
        installationAddress?.address_details?.city,
        installationAddress?.address_details?.state,
        installationAddress?.address_details?.stateCode,
        installationAddress?.address_details?.zip,
    ]);

    const specialFeesKey = React.useMemo(() => {
        return selectedSpecialFees.map(f => `${f.id}-${f.amount}`).join('|');
    }, [selectedSpecialFees]);

    // ---- Single unified effect for all recompute triggers ----------------
    React.useEffect(() => {
        if (!ready) return;
        triggerRecomputeIfReady();
    }, [
        ready,
        addressKey,
        removalCost,
        specialFeesKey,
        triggerRecomputeIfReady,
    ]);

    const uploadFile = async (file: File): Promise<string> => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("uploadDir", "categories");

        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", `${process.env.REACT_APP_API_URL}/images/upload`, true);
            xhr.setRequestHeader("Authorization", `Bearer ${token}`);

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    setUploadProgress((event.loaded / event.total) * 100);
                }
            };

            xhr.onload = () => {
                if (xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    resolve(response.path);
                } else {
                    reject(new Error("Failed to upload file"));
                }
            };

            xhr.onerror = () => reject(new Error("Network error during file upload"));
            xhr.send(formData);
        });
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.currentTarget.files?.[0];
        if (file) {
            formik.setFieldValue("image", file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleLocationChange = (
        selectedOption: SingleValue<{ value: string; label: string }>
    ) => {
        formik.setFieldValue("location", selectedOption?.value || "");
    };

    const handleMapClick = useCallback((event: google.maps.MapMouseEvent) => {
        if (event.latLng) {
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            setSelectedLocation({ lat, lng });
            formik.setFieldValue("location", { lat, lng });
        }
    }, []);

    const handleSaveInstructions = (newInstructions: string) => {
        setInstructions(newInstructions);
        formik.setFieldValue("instructions", newInstructions);
    };


    if (!isLoaded) return <div>Loading...</div>;

    return (
        <div className="content container">
            <div className="mb-4">
                <h3 className="m-0 fw-bold text-center removal-installation">Add Removal Request</h3>
            </div>
            <div className="my-3">
                <div className="d-flex justify-content-between align-items-center flex-wrap col-lg-12 os-card" style={{ boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)', borderRadius: '12px', padding: '20px', backgroundColor: 'white' }}>
                    {/* Left: Removal Status Tracker */}
                    <div className="flex-grow-1">
                        <InstallationStatusTracker type="removal" status={0} className="w-100" />
                    </div>
                </div>
            </div>
            <form onSubmit={formik.handleSubmit} className="me-2 me-lg-0">
                <div className="row col-md-12 card-body shadow-lg pb-4 mb-4 ms-0 p-3">
                    <div className="mb-3">
                        <SectionHeader title="Customer Information" icon="ri-user-3-line" color="#155dfc" size="md" divider />
                    </div>

                    <div className="col-md-3 mb-3">
                        <label className="form-label table-cells">
                            Search  Installation Job <span className="text-danger">*</span>
                        </label>
                        <AsyncPaginate
                            id="installation_order"
                            name="installation_order"
                            value={
                                selectedInstallationOption ||
                                (formik.values.installation_order
                                    ? { value: formik.values.installation_order, label: formik.values.order_number }
                                    : null)
                            }
                            loadOptions={loadCompletedInstallationOrderOptions}
                            onChange={async (selectedOption: any) => {
                                if (selectedOption) {
                                    setSelectedInstallationOption({ value: selectedOption.value, label: selectedOption.label });
                                    setSelectedSpecialFees([]);
                                    formik.setFieldValue("specialfee", [], false);
                                    formik.setFieldValue("totals.specialfee_subtotal", 0, false);
                                    formik.setFieldValue("totals.specialfee_tax_amount", 0, false);
                                    fetchRemovalOrder(selectedOption.value);
                                    formik.setFieldValue('order_number', selectedOption.label);
                                    formik.setFieldValue('installation_order', selectedOption.value);
                                    const id = await ensureDraftUniqueId(token || "");
                                    if (id) formik.setFieldValue("draft_unique_id", id, false);
                                } else {
                                    setSelectedInstallationOption(null);
                                    setSelectedSpecialFees([]);
                                    formik.setFieldValue("specialfee", [], false);
                                    formik.setFieldValue("totals.specialfee_subtotal", 0, false);
                                    formik.setFieldValue("totals.specialfee_tax_amount", 0, false);
                                    formik.setFieldValue('order_number', '');
                                    formik.setFieldValue('installation_order', '');
                                }
                            }}
                            additional={{ page: 1 }}
                            defaultOptions
                            debounceTimeout={300}
                            placeholder="Search and select an order..."
                            components={{ DropdownIndicator }}
                            styles={customSelectStyles}
                            classNamePrefix="rs"
                        />
                    </div>

                    <div className="col-md-3 mb-3">
                        <label htmlFor="agent" className="form-label table-headers">Agent Name <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className={`form-control table-cells ${formik.touched.agent && formik.errors.agent ? "is-invalid" : ""}`}
                            id="agent"
                            name="agent"
                            value={formik.values.agent}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            readOnly
                        />
                        {formik.touched.agent && typeof formik.errors.agent === "string" && (
                            <div className="invalid-feedback d-block">{formik.errors.agent}</div>
                        )}
                    </div>

                    <div className="col-md-3 mb-3">
                        <label htmlFor="userEmail" className="form-label table-headers">Email <span className="text-danger">*</span></label>
                        <input
                            type="email"
                            className={`form-control table-cells ${(formik.submitCount > 0 || formik.touched.userEmail) && formik.errors.userEmail ? "is-invalid" : ""}`}
                            id="userEmail"
                            name="userEmail"
                            placeholder="Enter email"
                            value={formik.values.userEmail}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {(formik.submitCount > 0 || formik.touched.userEmail) && typeof formik.errors.userEmail === "string" && (
                            <div className="invalid-feedback d-block">{formik.errors.userEmail}</div>
                        )}
                    </div>

                    <div className="col-md-3 mb-3">
                        <label htmlFor="userPhone" className="form-label  table-headers">
                            Phone <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            className={`form-control table-cells ${(formik.submitCount > 0 || formik.touched.userPhone) && formik.errors.userPhone ? "is-invalid" : ""}`}
                            id="userPhone"
                            name="userPhone"
                            placeholder="Enter phone"
                            value={formik.values.userPhone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        {(formik.submitCount > 0 || formik.touched.userPhone) && typeof formik.errors.userPhone === "string" && (
                            <div className="invalid-feedback d-block">{formik.errors.userPhone}</div>
                        )}
                    </div>
                </div>
                <div className="d-block d-lg-flex gap-3">
                    <div className="col-md-8">
                        <div className="row col-md-12 card-body shadow-lg mb-4 ms-0 p-3">
                            <div className="mb-3">
                                <SectionHeader title="Schedule & Assignment" icon="ri-calendar-line" color="#00a63e" size="md" divider />
                            </div>
                            <div className="col-md-3 mb-3">
                                <label className="form-label table-cells">
                                    Removal Date <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="date"
                                    min={new Date().toISOString().split("T")[0]}
                                    className={`form-control ${formik.touched.removal_date && formik.errors.removal_date ? "is-invalid" : ""}`}
                                    id="removal_date"
                                    name="removal_date"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.removal_date}
                                />
                                {formik.touched.removal_date && formik.errors.removal_date && (
                                    <div className="invalid-feedback">{formik.errors.removal_date}</div>
                                )}

                            </div>
                            <div className="col-md-3 mb-3">
                                <label className="form-label table-cells">
                                    Removal Priority <span className="text-danger">*</span>
                                </label>
                                <Select
                                    id="priority"
                                    name="priority"
                                    options={[
                                        { value: "3", label: "Normal" },
                                        { value: "2", label: "High Priority" },
                                        { value: "1", label: "Critical" },
                                    ]}
                                    onChange={(option: SingleValue<{ value: string; label: string }>) =>
                                        formik.setFieldValue("priority", option?.value || "")
                                    }
                                    components={{ DropdownIndicator }}
                                    styles={customSelectStyles}
                                    onBlur={() => formik.setFieldTouched("priority", true)}
                                />
                                {(formik.submitCount > 0 || formik.touched.priority) && formik.errors.priority && (
                                    <div className="text-danger">{formik.errors.priority}</div>
                                )}
                            </div>
                        </div>

                        <div className="row col-md-12 mb-4 card-body shadow-lg mb-4 ms-0 pb-3 p-3">
                            <div className="col-lg-12 d-flex mb-3">
                                {/* Address: teal */}
                                <SectionHeader title="Address Information" icon="ri-map-pin-line" color="#e7000b" size="md" divider className="col-lg-4" />
                                <div className="align-items-baseline col-lg-8 d-flex mb-3 justify-content-end">
                                    <div className="align-items-baseline col-lg-6 d-flex justify-content-end">
                                        <label className="me-2">Gate Code</label>
                                        <input type="text" id="gatecode" name="gatecode" className="form-control w-50" value={formik.values.gatecode} onChange={formik.handleChange} onBlur={formik.handleBlur} placeholder="Enter Gate Code" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="align-items-baseline col-md-12 d-flex justify-content-end">
                                    {/* <div className="d-flex fw-bold gap-2 my-2">
                                        <input
                                            type="checkbox"
                                            id="isSameAsBilling"
                                            name="isSameAsBilling"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            checked={formik.values.isSameAsBilling}
                                        />{" "}
                                        Billing and Installation Address are Same

                                    </div> */}
                                    <button
                                        className="btn btn-primary table-addbutton"
                                        type="button"
                                        onClick={() => setShowAddressForm(true)}
                                        title={formik.values.billingAddressId ? "Billing address selected" : "Add new address"}
                                    >
                                        + Address
                                    </button>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label
                                            htmlFor="billingAddressId"
                                            className="form-label table-cells"
                                        >
                                            Billing Address <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            // className="form-control"
                                            id="billingAddress"
                                            name="billingAddress"
                                            options={addressOptions}
                                            value={addressOptions?.find((option) => option.value === formik.values.billingAddressId) || null}
                                            onChange={(selected) => {
                                                safeConsole.log("Selected Billing Address:", selected);
                                                formik.setFieldValue("billingAddressId", selected?.value);
                                                const selectedAddress =
                                                    addressObjects?.find((addr) => addr._id === selected?.value) ??
                                                    (selected && typeof selected === "object" && selected._id
                                                        ? selected
                                                        : null);
                                                setSelectedBillingAddress(selectedAddress);
                                                formik.setFieldValue("isSameAsBilling", false);
                                            }}
                                            onBlur={() => formik.setFieldTouched("billingAddressId", true)}
                                            components={{ DropdownIndicator }}
                                            styles={customSelectStyles}
                                        />
                                        {(formik.submitCount > 0 || formik.touched.billingAddressId) &&
                                            typeof formik.errors.billingAddressId === "string" && (
                                                <div className="text-danger mt-1">{formik.errors.billingAddressId}</div>
                                            )}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label
                                            htmlFor="removalAddressId"
                                            className="form-label table-cells mt-2"
                                        >
                                            Removal Address <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="removalAddressId"
                                            value={
                                                installationAddress?.address_details?.addressLine1 ||
                                                    installationAddress?.address_details?.city ||
                                                    installationAddress?.address_details?.state
                                                    ? [
                                                        installationAddress?.address_details?.addressLine1,
                                                        installationAddress?.address_details?.city,
                                                        installationAddress?.address_details?.state
                                                    ].filter(Boolean).join(', ')
                                                    : ''
                                            }
                                            placeholder="Removal Address"
                                            className={`form-control ${(formik.submitCount > 0 || formik.touched.removalAddressId) && formik.errors.removalAddressId ? "is-invalid" : ""}`}
                                            disabled
                                        />
                                        {(formik.submitCount > 0 || formik.touched.removalAddressId) &&
                                            typeof formik.errors.removalAddressId === "string" && (
                                                <div className="text-danger mt-1">{formik.errors.removalAddressId}</div>
                                            )}
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-12">
                                <div style={mapContainerStyle}>
                                    <GoogleMap
                                        mapContainerStyle={mapContainerStyle}
                                        zoom={10}
                                        center={selectedLocation || center}
                                    // onClick={handleMapClick}
                                    >
                                        {selectedLocation && <Marker
                                            position={selectedLocation}
                                            draggable={false}
                                        // onDragEnd={handleMarkerDragEnd}
                                        />}
                                    </GoogleMap>
                                </div>
                            </div>
                        </div>
                        <div className="row col-md-12 mb-5 card-body shadow-lg mb-3 ms-0 p-3">
                            <div className="d-flex mb-3">
                                <span
                                    aria-hidden="true"
                                    className="image-icons"
                                    style={{
                                        backgroundColor: "#9810fa",
                                        WebkitMaskImage: `url(${ProductSelection})`,
                                        maskImage: `url(${ProductSelection})`,
                                    }}
                                />
                                <SectionHeader title="Product Selection" icon="" variant="success" size="md" divider />
                            </div>
                            {/* Desktop Table View */}
                            <div className="col-md-12 ms-3 d-none d-lg-block" id="row-overlap">
                                <table className="border table table-striped">
                                    <thead className="">
                                        <tr>
                                            <th className="text-center table-headers" style={{ width: "20%" }}>Product Name</th>
                                            <th className="text-center table-headers" style={{ width: "8%" }}>SKU</th>
                                            <th className="text-center table-headers" style={{ width: "13%" }}>Installation Qty </th>
                                            <th className="text-center table-headers" style={{ width: "12%" }}>Qty to remove </th>
                                            <th className="text-center table-headers" style={{ width: "20%" }}>Product Location Status</th>
                                            {/* <th className="text-center">Action</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {products?.filter((item: any) => {
                                            // Only show non-rotational products with remaining quantity > 0
                                            if (item.inventory_source === "rotational") {
                                                return false;
                                            } else {
                                                const alreadyRemoved = getAlreadyRemovedQuantity(item.product_id);
                                                const availableQuantity = Math.max(0, item.quantity - alreadyRemoved);
                                                return availableQuantity > 0;
                                            }
                                        })?.map((item: any, index: number) => (
                                            <tr key={index}>
                                                <td className="text-center table-cells text-ellipsis">{item.product_name}</td>
                                                <td className="text-center table-cells">{displayRemovalSku(item)}</td>
                                                <td className="text-center table-cells">{getAvailableQuantity(item)}</td>
                                                <td className="text-center table-cells">
                                                    <input
                                                        type="number"
                                                        className="form-control text-center table-cells"
                                                        value={removalQuantities[item.product_id] || ""}
                                                        placeholder="0"
                                                        onChange={(e) => {
                                                            const inputVal = parseInt(e.target.value) || 0;
                                                            const availableQty = getAvailableQuantity(item);
                                                            const clampedVal = Math.min(inputVal, availableQty);
                                                            setRemovalQuantities((prev) => ({
                                                                ...prev,
                                                                [item.product_id]: clampedVal,
                                                            }));
                                                        }}
                                                        onWheel={(e) => e.currentTarget.blur()}
                                                    />
                                                </td>
                                                <td className="text-center table-cells">
                                                    <span className=" p-2">
                                                        <StatusBadge status={item.current_status?.replace(/_/g, " ") || "--"} />
                                                        {/* {item.current_status} */}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Mobile/Tablet Card View */}
                            <div className="col-md-12 d-lg-none">
                                <div className="row g-3">
                                    {products?.filter((item: any) => {
                                        // Only show non-rotational products with remaining quantity > 0
                                        if (item.inventory_source === "rotational") {
                                            return false;
                                        } else {
                                            const alreadyRemoved = getAlreadyRemovedQuantity(item.product_id);
                                            const availableQuantity = Math.max(0, item.quantity - alreadyRemoved);
                                            return availableQuantity > 0;
                                        }
                                    })?.map((item: any, index: number) => (
                                        <div key={index} className="col-12 mb-3">
                                            <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '8px' }}>
                                                <div className="card-body p-3">
                                                    {/* Product Name - Top Row */}
                                                    <div className="mb-3">
                                                        <h6>Product Name</h6>
                                                        <h6 className="card-title mb-0 fw-medium">
                                                            {item.product_name}
                                                        </h6>
                                                    </div>

                                                    {/* Quantity Inputs - Second Row */}
                                                    <div className="row g-2 mb-3">
                                                        <div className="col-6">
                                                            <label className="form-label small mb-1">Installation Qty</label>
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm text-center"
                                                                value={getAvailableQuantity(item)}
                                                                readOnly
                                                                style={{ backgroundColor: '#f8f9fa' }}
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <label className="form-label small mb-1">Qty to Remove</label>
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm text-center"
                                                                value={removalQuantities[item.product_id] || ""}
                                                                placeholder="0"
                                                                min="0"
                                                                max={getAvailableQuantity(item)}
                                                                onChange={(e) => {
                                                                    const inputVal = parseInt(e.target.value) || 0;
                                                                    const availableQty = getAvailableQuantity(item);
                                                                    const clampedVal = Math.min(inputVal, availableQty);
                                                                    setRemovalQuantities((prev) => ({
                                                                        ...prev,
                                                                        [item.product_id]: clampedVal,
                                                                    }));
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* SKU and Status - Bottom Row */}
                                                    <div className="row g-2">
                                                        <div className="col-6">
                                                            <h6>SKU</h6>
                                                            <span className="fw-medium">{displayRemovalSku(item)}</span>
                                                        </div>
                                                        <div className="col-6">
                                                            <h6>Product Location Status</h6>
                                                            <StatusBadge status={item.current_status?.replace(/_/g, " ") || "--"} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="row col-md-12 mb-3">
                            <div className="col-lg-6 mb-3 mb-lg-0 pe-0">
                                <InstructionsCreateCard
                                    title="Instructions"
                                    // mode="instructions_files"
                                    loginType="signage"
                                    value={formik.values.instructions}
                                    onChange={(v) => formik.setFieldValue("instructions", v, false)}
                                    placeholder="Add instructions here"
                                    rows={4}
                                    className="mt-3"
                                    iconUrl={OrderNotes}
                                    iconColor="#f54a00"
                                    iconBackground="#EAF7F1"
                                />
                            </div>
                            <div className="align-items-center card-body col-lg-5 justify-content-end ms-0 ms-2 ms-lg-0 ms-lg-5 offset-1 p-4 shadow-lg">
                                <div className="align-items-center d-flex mb-3">
                                    <span
                                        aria-hidden="true"
                                        className="image-icons"
                                        style={{
                                            backgroundColor: "#00a63e",
                                            WebkitMaskImage: `url(${Doller})`,
                                            maskImage: `url(${Doller})`,
                                        }}
                                    />
                                    <SectionHeader title="Cost Breakdown" icon="" color="" size="lg" divider />
                                </div>
                                {removalOrder?.seller_owner_node_id && effectiveCouponCreatedById && (
                                    <>
                                        <OrderDiscountCodeField
                                            className="mb-2"
                                            value={couponInput}
                                            appliedCode={liveDiscountDisplay.code}
                                            discountAmount={liveDiscountDisplay.amount}
                                            disabled={isRecomputing}
                                            onChange={setCouponInput}
                                            onApply={(code: string) => {
                                                const trimmed = code.trim();
                                                if (!trimmed) return;
                                                userClearedCouponRef.current = false;
                                                setCouponInput(trimmed);
                                                formik.setFieldValue("discount_code", trimmed, false);
                                                void recompute({ force: true, discountCode: trimmed });
                                            }}
                                            onClear={() => {
                                                userClearedCouponRef.current = true;
                                                setCouponInput("");
                                                formik.setFieldValue("discount_code", "", false);
                                                formik.setFieldValue("discount_amount", 0, false);
                                                setZeroOrNegativeMsg("");
                                                void recompute({ force: true, discountCode: "" });
                                            }}
                                        />
                                        {zeroOrNegativeMsg && <div className="text-danger mt-2">{zeroOrNegativeMsg}</div>}
                                    </>
                                )}
                                <hr />

                                <div className="d-flex justify-content-between align-items-center py-2">
                                    <span className="fw-medium">Total Units:</span>
                                    <span className="fw-semibold">{Object.values(removalQuantities).reduce((sum, qty) => sum + qty, 0)}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center py-2">
                                    <span className="fw-medium">Removal Cost:</span>
                                    <span className="fw-semibold">${removalCostDisplay.toFixed(2)}</span>
                                </div>

                                <div className="d-flex justify-content-between align-items-center py-2">
                                    <span className="fw-medium">Sub-total:</span>
                                    <span className="fw-semibold">${subtotalDisplay.toFixed(2)}</span>
                                </div>
                                {discountAmountDisplay > 0 && (
                                    <div className="d-flex justify-content-between align-items-center py-2">
                                        <span className="fw-medium" style={{ color: "#00a63e" }}>Discount:{formik.values.discount_code}</span>
                                        <span className="fw-semibold text-success" style={{ color: "#00a63e" }}>
                                            -${discountAmountDisplay.toFixed(2)}
                                        </span>
                                    </div>
                                )}

                                <div className="d-flex justify-content-between align-items-center py-2">
                                    {(() => {
                                        const { labelText, tooltip } = buildSpecialFeeCostBreakdownDisplay(selectedSpecialFees);
                                        return (
                                            <>
                                                <span className="fw-medium me-2" style={{ minWidth: 0 }} title={tooltip}>
                                                    {labelText}:
                                                </span>
                                                <span className="fw-semibold flex-shrink-0">
                                                    ${specialFeeSubtotalDisplay.toFixed(2)}
                                                </span>
                                            </>
                                        );
                                    })()}
                                </div>

                                <div className="py-1">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <button
                                            type="button"
                                            onClick={() => setShowTaxDetails(v => !v)}
                                            className="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center"
                                            aria-expanded={showTaxDetails}
                                            aria-controls="tax-breakdown"
                                        >
                                            {/* <i className={`bi ${showTaxDetails ? "bi-chevron-down" : "bi-chevron-right"} me-1`} /> */}
                                            <span className="order-card-title">Tax :</span>
                                        </button>
                                        <span className="order-card-cells">
                                            <span>
                                                ${combinedTaxDisplay.toFixed(2)}
                                            </span>
                                        </span>
                                    </div>

                                    {/* {showTaxDetails && (
                                        <div id="tax-breakdown" className="border rounded-3 p-2 bg-light mt-1">
                                            <div className="d-flex justify-content-between small mb-1">
                                                <span>Removal Tax</span>
                                                <span className="order-card-cells">
                                                    ${Number(formik.values.totals.removal_tax_amount).toFixed(2)}
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between small">
                                                <span>Special Fee Tax</span>
                                                <span className="order-card-cells">
                                                    ${Number(formik.values.totals.specialfee_tax_amount).toFixed(2)}
                                                </span>
                                            </div>
                                        </div>
                                    )} */}
                                </div>

                                <hr className="my-3" />

                                <div className="d-flex justify-content-between align-items-center py-2">
                                    <span className="fw-bold fs-5">Total Amount:</span>
                                    <span className="fw-bold fs-5 text-primary">
                                        ${totalAmountDisplay.toFixed(2)}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="row mb-3 col-lg-12 rcust-margin-4 mt-4">
                            <div className="col-lg-12 d-block d-lg-flex justify-content-between">
                                {/* Left: Back */}
                                <div className="col-lg-2">
                                    <button
                                        className="btn back-btn surface-btn fw-bold fs-16 w-100"
                                        type="button"
                                        onClick={() => safeNavigate(-1)}
                                    >
                                        <i className="bi bi-chevron-left me-2" />
                                        Back
                                    </button>
                                </div>
                                {/* Right: checkbox + submit */}
                                <div className="d-block d-lg-flex align-items-baseline justify-content-end">
                                    <div className="col-lg-10 mt-3">
                                        <div className="d-flex d-lg-block form-check justify-content-center mb-3 mb-lg-0 gap-3">
                                            <input
                                                type="checkbox"
                                                id="localLaws"
                                                name="localLawsChecked"
                                                className="form-check-input"
                                                checked={formik.values.localLawsChecked}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                            <label htmlFor="localLaws" className="form-check-label mb-0 text-nowrap">
                                                I Acknowledge to local laws
                                            </label>
                                        </div>
                                    </div>
                                    <button
                                        type="submit"
                                        className="btn btn-primary save-btn surface-btn fw-bold fs-16 w-100"
                                        disabled={formSubmitting || isRecomputing || !formik.values.localLawsChecked}
                                    >
                                        {isRecomputing ? "Calculating..." : "Save Draft"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {removalSpecialFeeSupplierId && removalSpecialFeePersonId && (
                    <div className="col-lg-3 card-body">
                        <PONumber
                            mode="create"
                            className="mb-3"
                            value={String(formik.values.po_number || "")}
                            onChange={(v) => formik.setFieldValue("po_number", v)}
                        />
                        {/* 👉 Special Fees UI */}
                        <SpecialFeeui
                            token={token || ""}
                            personId={removalSpecialFeePersonId}
                            supplierId={removalSpecialFeeSupplierId}
                            order={removalOrder}
                            orderId={String(removalOrder?._id || removalOrder?.id || id || "").trim()}
                            orderType="installation"
                            formik={formik}
                            name="specialfee"
                            apiBase={process.env.REACT_APP_API_URL || ""}
                            readOnly={false}
                            autoSelectRequired={false}
                            disabled={isRecomputing}  // ✅ Disable special fee selection when recompute is running
                            title="Special Fees"
                            onOptionsLoaded={(allOptions) => {
                                // ✅ Receive all available fees (including required field) from component
                                setAllAvailableSpecialFees(allOptions);
                                safeConsole.log("All available special fees from component:", allOptions);
                            }}
                            onUserChange={(nextFees) => {
                                // ✅ Don't process if recompute is running (prevents duplicate calls)
                                if (isRecomputingRef.current) {
                                    safeConsole.log("⏸️ Recompute in progress, skipping special fee change");
                                    return;
                                }

                                safeConsole.log("Received from child:", nextFees);

                                const feeSig = nextFees.map((f: any) => `${f.id}:${Number(f.amount || 0)}`).sort().join(",");
                                const prevSig = selectedSpecialFees.map((f: any) => `${f.id}:${Number(f.amount || 0)}`).sort().join(",");

                                setSelectedSpecialFees(nextFees);
                                formik.setFieldValue("specialfee", nextFees, false);

                                if (feeSig !== prevSig) {
                                    void recompute({ fees: nextFees });
                                }
                            }}

                        />
                    </div>
                    )}
                </div>
                {showAddressForm && (
                    <AddressFormModal
                        isOpen={true}
                        onClose={() => {
                            setShowAddressForm(false);
                        }}
                        token={token || ""}
                        owner={{
                            value: userId || "",
                            label: userName || "",
                        }}
                        useType="billing"
                        prefill={{
                            label_of_address: formik?.values?.label_of_address || "",
                            firstName: formik?.values?.firstName || "",
                            lastName: formik?.values?.lastName || "",
                            company: formik?.values?.company || "",
                            phone: formik?.values?.phone || "",
                            addressLine1: formik?.values?.addressLine1 || "",
                            addressLine2: formik?.values?.addressLine2 || "",
                            city: formik?.values?.city || "",
                            state: formik?.values?.state || "",
                            zipcode: formik?.values?.zipcode || "",
                            country: formik?.values?.country || "",
                        }}
                        onCreated={(createdRaw, option, useType) => {
                            // Add the new address to the address list
                            setAddressObjects((prev) => [createdRaw, ...(prev || [])]);

                            // Set the billing address field value
                            formik.setFieldValue(
                                useType === "billing" ? "billingAddressId" : "shippingAddressId",
                                option.value
                            );

                            // Only update billing address state, NOT installation/removal address
                            // Removal address should always remain as the installation order's address
                            if (useType === "billing") {
                                setSelectedBillingAddress(createdRaw);
                            }

                            // Note: We don't update installationAddress here because it should
                            // always be the address from the installation order
                        }}
                        afterCreateRefresh={() => {
                            // Refresh the addresses list
                            if (userId) {
                                const fetchAddresses = async () => {
                                    try {
                                        const response = await fetch(
                                            `${process.env.REACT_APP_API_URL}/user-addresses/${userId}`,
                                            {
                                                method: "GET",
                                                headers: {
                                                    Authorization: `Bearer ${token}`,
                                                    "Content-Type": "application/json",
                                                },
                                            }
                                        );
                                        const data = await response.json();
                                        setAddressObjects(data);
                                    } catch (err) {
                                        await handleApiError(err, {
                                            module: "removal",
                                            action: "Agent_Add_Removal_Request_fetch_addresses_refresh",
                                            userId: userId || undefined,
                                            licenseType: licenseType || undefined,
                                            userName: userName || undefined,
                                            url: `${process.env.REACT_APP_API_URL}/user-addresses/${userId}`,
                                            method: "GET",
                                        }, token);
                                        safeConsole.error("Error fetching addresses:", err);
                                    }
                                };
                                fetchAddresses();
                            }
                        }}
                    />
                )}
            </form>
            <div >
            </div>
        </div >
    );
};

export default AgentAddRemovalRequest;


//    <form onSubmit={formik.handleSubmit}>
//                     <div className="row mt-2">
//                         <div className="col-md-5 mb-3">
//                             <label className="form-label table-cells">
//                                 Search Installation Job Order
//                             </label>
//                             <Select
//                                 id="installation_order"
//                                 name="installation_order"
//                                 options={complietInstallationOrdersOptions}
//                                 onChange={(selectedOption) => {
//                                     if (selectedOption) {
//                                         fetchRemovalOrder(selectedOption.value);
//                                         formik.setFieldValue('order_number', selectedOption.label);
//                                     }
//                                 }}
//                                 value={complietInstallationOrdersOptions?.find(option => option.label === formik.values.order_number) || null}
//                                 placeholder="Search and select an order..."
//                                 isClearable
//                                 isSearchable
//                             />
//                         </div>

//                         <div className="col-md-3 mb-3">
//                             <label className="form-label table-cells">
//                                 Removal Priority
//                             </label>
//                             <Select
//                                 id="priority"
//                                 name="priority"
//                                 options={[
//                                     { value: "3", label: "Normal" },
//                                     { value: "2", label: "High Priority" },
//                                     { value: "1", label: "Critical" },
//                                 ]}
//                                 onChange={(option: SingleValue<{ value: string; label: string }>) =>
//                                     formik.setFieldValue("priority", option?.value || "")
//                                 }
//                                 onBlur={formik.handleBlur}
//                             />
//                             {formik.touched.priority && formik.errors.priority && (
//                                 <div className="text-danger">{formik.errors.priority}</div>
//                             )}
//                         </div>

//                         <div className="col-md-3 mb-3">
//                             <label className="form-label table-cells">
//                                 Removal Date
//                             </label>
//                             <input
//                                 type="date"
//                                 className="form-control"
//                                 id="removal_date"
//                                 name="removal_date"
//                                 onChange={formik.handleChange}
//                                 onBlur={formik.handleBlur}
//                                 value={formik.values.removal_date}
//                             />
//                             {formik.touched.removal_date &&
//                                 formik.errors.removal_date && (
//                                     <div className="invalid-feedback">
//                                         {formik.errors.removal_date}
//                                     </div>
//                                 )}
//                         </div>
//                     </div>

//                     <div className="row mb-3 me-3">
//                         <div className="col-md-12">
//                             <h3>Address details</h3>
//                         </div>
//                         <div className="col-sm-5">
//                             <label
//                                 htmlFor="billingAddressId"
//                                 className="form-label table-cells"
//                             >
//                                 Billing Address
//                             </label>
//                             <Select
//                                 className="form-control"
//                                 id="billingAddress"
//                                 name="billingAddress"
//                                 options={addressOptions}
//                                 value={addressOptions?.find((option) => option.value === formik.values.billingAddressId) || null}
//                                 onChange={(selected) => {
//                                     safeConsole.log("Selected Billing Address:", selected); // Debugging log
//                                     formik.setFieldValue("billingAddressId", selected?.value);
//                                     const selectedAddress = addressObjects?.find(
//                                         (addr) => (addr.address_details ? addr.address_details._id : addr._id) === selected?.value
//                                     );
//                                     setSelectedBillingAddress(selectedAddress?.address_details);
//                                 }}
//                             />
//                         </div>
//                         <div className="col-sm-3">
//                             <label
//                                 htmlFor="removalAddressId"
//                                 className="form-label table-cells"
//                             >
//                                 Removal Address
//                             </label>
//                             <input type="text" value={`${installationAddress?.addressLine1}, ${installationAddress?.city}, ${installationAddress?.state}`} className="form-control" disabled />
//                         </div>
//                     </div>

//                     {/* <div className="row mb-3">
//                             <div className="col-md-12">
//                                 <h3>Address details</h3>
//                             </div>
//                             <div className="col-sm-6">
//                                 <label
//                                     htmlFor="billingAddressId"
//                                     className="form-label table-cells"
//                                 >
//                                     Billing Address
//                                 </label>
//                                 <Select
//                                     className="form-control"
//                                     id="billingAddress"
//                                     name="billingAddress"
//                                     options={addressOptions}
//                                     value={addressOptions?.find((option) => option.value === formik.values.billingAddressId) || null}
//                                     onChange={(selected) => {
//                                         safeConsole.log("Selected Billing Address:", selected); // Debugging log
//                                         formik.setFieldValue("billingAddressId", selected?.value);
//                                         const selectedAddress = addressObjects?.find(
//                                             (addr) => (addr.address_details ? addr.address_details._id : addr._id) === selected?.value
//                                         );
//                                         setSelectedBillingAddress(selectedAddress?.address_details);
//                                     }}
//                                 />
//                             </div>
//                             <div className="col-sm-6">
//                                 <label
//                                     htmlFor="removalAddressId"
//                                     className="form-label"
//                                 >
//                                     Removal Address
//                                 </label>
//                                 <input type="text" value={`${installationAddress?.addressLine1}, ${installationAddress?.city}, ${installationAddress?.state}`} className="form-control" disabled />
//                             </div>
//                         </div> */}
//                     <div className="row mb-3 me-1">
//                         <div className="col-md-12">
//                             {/* <h3>
//                                     <input type="checkbox" name="isAddressesDifferent" id="isAddressesDifferent" className="me-3" />
//                                     Billing Address is Different</h3>
//                                 <p>Adjust Location on Map</p> */}
//                             <h5>Map View</h5>
//                             <div style={mapContainerStyle}>
//                                 <GoogleMap
//                                     mapContainerStyle={mapContainerStyle}
//                                     zoom={10}
//                                     center={selectedLocation || center}
//                                 // onClick={handleMapClick}
//                                 >
//                                     {selectedLocation && <Marker position={selectedLocation} />}
//                                 </GoogleMap>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="row mb-3 me-3">
//                         <div className="col-md-12">
//                             <h4 className="table-headers">Product details </h4>
//                             <div className="row mb-5">
//                                 <div className="col-md-12 ps-0 ms-2 me-3">
//                                     <table className="table table-bordered">
//                                         <thead className="bg-primary-subtle">
//                                             <tr>
//                                                 <th className="text-center table-headers">Product Name</th>
//                                                 <th className="text-center table-headers">SKU</th>
//                                                 <th className="text-center table-headers">Available Quantity </th>
//                                                 <th className="text-center table-headers">Quantity to remove </th>
//                                                 <th className="text-center table-headers">Product Location Status</th>
//                                                 {/* <th className="text-center">Action</th> */}
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {products?.filter((item: any) => item.inventory_source !== "rotational").map((item: any, index: number) => (
//                                                 <tr key={index}>
//                                                     <td className="text-center table-cells">{item.product_name}</td>
//                                                     <td className="text-center table-cells">{item.sku}</td>
//                                                     <td className="text-center table-cells">{item.quantity}</td>
//                                                     <td className="text-center table-cells">
//                                                         <input
//                                                             type="number"
//                                                             className="form-control text-center table-cells"
//                                                             value={removalQuantities[item.product_id] || ""}
//                                                             placeholder="0"
//                                                             // min={1}
//                                                             onChange={(e) => {
//                                                                 const inputVal = parseInt(e.target.value) || 1;
//                                                                 const clampedVal = Math.min(inputVal, item.quantity); // ✅ cap at max available

//                                                                 setRemovalQuantities((prev) => ({
//                                                                     ...prev,
//                                                                     [item.product_id]: clampedVal,
//                                                                 }));
//                                                             }}
//                                                         />
//                                                     </td>
//                                                     <td className="text-center table-cells">
//                                                         <span className="bg-warning p-2 rounded-4">{item.current_status}</span>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                             </div>

//                         </div>
//                     </div>
//                     <div className="row mb-4  me-34">

//                         {/* Right: Instructions */}
//                         <div className="col-md-6">
//                             <label htmlFor="instructions" className="form-label table-cells">
//                                 Additional Instructions
//                             </label>
//                             <textarea
//                                 name="instructions"
//                                 id="instructions"
//                                 className="form-control"
//                                 rows={5}
//                                 placeholder="Enter any additional instructions or notes..."
//                                 value={formik.values.instructions}
//                                 onChange={formik.handleChange}
//                                 onBlur={formik.handleBlur}
//                             ></textarea>
//                         </div>
//                         <div className="col-md-2"></div>
//                         {/* Left: Charges Summary */}
//                         <div className="col-md-4">
//                             <table className="table table-bordered table-sm align-middle bg-light">
//                                 <thead>
//                                     <tr>
//                                         <th colSpan={2} className="table-headers bg-white text-center">Charges Summary</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     <tr>
//                                         <th className="bg-light table-headers">Total Units to Remove</th>
//                                         <td className="fw-semibold table-cells text-center">{Object.values(removalQuantities).reduce((sum, qty) => sum + qty, 0)}</td>
//                                     </tr>
//                                     <tr>
//                                         <th className="table-headers">Removal Cost</th>
//                                         <td className="table-cells text-center ">
//                                             ${Number(removalCost).toFixed(2)}
//                                         </td>
//                                     </tr>

//                                     <tr>
//                                         <th className="table-headers">Subtotal</th>
//                                         <td className="table-cells text-center  fw-semibold">
//                                             ${Number(formik.values.subtotal).toFixed(2)}
//                                         </td>
//                                     </tr>

//                                     <tr>
//                                         <th className="table-headers">Tax</th>
//                                         <td className="table-cells text-center ">
//                                             ${Number(formik.values.tax).toFixed(2)}
//                                         </td>
//                                     </tr>

//                                     <tr>
//                                         <th className="table-headers">Total</th>
//                                         <td className="table-cells text-center ">
//                                             ${Number(removalCost ? formik.values.total : "").toFixed(2)}
//                                         </td>
//                                     </tr>
//                                 </tbody>
//                             </table>

//                             {/* <table className="table table-bordered table-sm align-middle bg-light">
//                                 <thead>
//                                     <tr>
//                                         <th colSpan={2} className="table-headers bg-white text-center">Charges Summary</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     <tr>
//                                         <th className="table-headers">Removal Fee</th>
//                                         <td className="table-cells text-end">
//                                             <div className="input-group input-group-sm justify-content-end" style={{ maxWidth: 120, marginLeft: "auto" }}>
//                                                 <span className="input-group-text bg-light px-2">$</span>
//                                                 <input
//                                                     type="number"
//                                                     name="removal_fee"
//                                                     id="removal_fee"
//                                                     className="form-control form-control-sm text-end"
//                                                     value={Number(removalCost)?.toFixed(2) ?? "0.00"}
//                                                     onChange={(e) => setRemovalCost(Number(e.target.value))}
//                                                 />
//                                             </div>
//                                         </td>
//                                     </tr>

//                                     <tr>
//                                         <th className="table-headers">Subtotal</th>
//                                         <td className="table-cells text-end fw-semibold">
//                                             ${Number(formik.values.subtotal).toFixed(2)}
//                                         </td>
//                                     </tr>

//                                     <tr>
//                                         <th className="table-headers">Tax</th>
//                                         <td className="table-cells text-end">
//                                             <div className="input-group input-group-sm justify-content-end" style={{ maxWidth: 120, marginLeft: "auto" }}>
//                                                 <span className="input-group-text bg-light px-2">$</span>
//                                                 <input
//                                                     type="number"
//                                                     name="tax"
//                                                     id="tax"
//                                                     className="form-control form-control-sm text-end"
//                                                     value={Number(formik.values.tax).toFixed(2)}
//                                                     onChange={formik.handleChange}
//                                                     onBlur={formik.handleBlur}
//                                                 />
//                                             </div>
//                                         </td>
//                                     </tr>

//                                     <tr>
//                                         <th className="table-headers">Total</th>
//                                         <td className="table-cells text-end fw-bold text-success">
//                                             ${Number(formik.values.total).toFixed(2)}
//                                         </td>
//                                     </tr>
//                                 </tbody>
//                             </table> */}
//                         </div>


//                     </div>
//                     {/* <div className="row mt-3">
//                         {previewFiles.map((item, index) => (
//                             <div key={index} className="col-md-3 position-relative mb-3">
//                                 <div
//                                     className="position-absolute top-0 end-0 bg-danger text-white rounded-circle"
//                                     style={{
//                                         width: "20px",
//                                         height: "20px",
//                                         textAlign: "center",
//                                         cursor: "pointer",
//                                         zIndex: 2,
//                                     }}
//                                     onClick={() => {
//                                         URL.revokeObjectURL(item.url); // cleanup
//                                         setPreviewFiles(previewFiles.filter((_, i) => i !== index));
//                                     }}
//                                 >
//                                     &times;
//                                 </div>
//                                 <div className="border p-2">
//                                     <img
//                                         src={item.url}
//                                         alt={`preview-${index}`}
//                                         className="img-fluid"
//                                         style={{ height: "150px", objectFit: "cover", width: "100%" }}
//                                     />
//                                     <div className="small text-center mt-1 text-muted">{item.file.name}</div>
//                                 </div>
//                             </div>
//                         ))}
//                     </div> */}
//                     <div className="row align-items-center mt-2 mb-4 me-3">
//                         {/* Left: Compliance label and checkbox (stacked vertically) */}
//                         <div className="col-md-8">
//                             <label className="fw-semibold mb-1" htmlFor="localLaws">
//                                 Local Laws Compliance :
//                             </label>
//                             <div className="form-check">
//                                 <input
//                                     type="checkbox"
//                                     id="localLaws"
//                                     name="localLawsChecked"
//                                     checked={formik.values.localLawsChecked}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                 />
//                                 <label htmlFor="localLaws" className="form-check-label ms-2">
//                                     I acknowledge adherence to local laws
//                                 </label>
//                             </div>
//                         </div>
//                         {/* Right: Button */}
//                         <div className="col-md-4 text-end">
//                             <button
//                                 type="submit"
//                                 className="btn btn-primary  px-4 table-cells"
//                                 disabled={formSubmitting || !formik.values.localLawsChecked}
//                             >
//                                 Submit Request
//                             </button>
//                         </div>
//                     </div>
//                 </form>




// <div className="row mb-3">
//     <div className="col-md-12">
//         <h4>Product details </h4>

//         <div className="row mb-5">
//             <div className="col-md-12">
//                 <table className="table table-bordered">
//                     <thead className="bg-primary-subtle">
//                         <tr>
//                             <th className="text-center">Product Name</th>
//                             <th className="text-center">SKU</th>
//                             <th className="text-center">Available Quantity </th>
//                             <th className="text-center">Quantity to remove </th>
//                             <th className="text-center">Product Location Status</th>
//                             {/* <th className="text-center">Action</th> */}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {products?.filter((item: any) => item.inventory_source !== "rotational").map((item: any, index: number) => (
//                             <tr key={index}>
//                                 <td className="text-center">{item.product_name}</td>
//                                 <td className="text-center">{item.sku}</td>
//                                 <td className="text-center">{item.quantity}</td>
//                                 <td className="text-center">
//                                     <input
//                                         type="number"
//                                         className="form-control text-center"
//                                         placeholder="0"
//                                         value={removalQuantities[item.product_id] || ""}
//                                         // min={1}
//                                         onChange={(e) => {
//                                             const inputVal = parseInt(e.target.value) || 1;
//                                             const clampedVal = Math.min(inputVal, item.quantity); // ✅ cap at max available

//                                             setRemovalQuantities((prev) => ({
//                                                 ...prev,
//                                                 [item.product_id]: clampedVal,
//                                             }));
//                                         }}
//                                     />
//                                 </td>
//                                 <td className="text-center">
//                                     <span className="bg-warning p-2 rounded-4">{item.current_status}</span>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>

//         </div>

//     </div>
// </div>

//  <div className="row mb-3">
//     <div className="col-md-6">
//         <div className="mb-3">
//             <label htmlFor="">Additional Instructions </label>
//             <textarea
//                 name="instructions"
//                 id="instructions"
//                 className="form-control"
//                 rows={4}
//                 placeholder="Enter additional instructions"
//                 value={formik.values.instructions}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//             ></textarea>
//         </div>
//     </div>
//     <div className="col-md-6">
//         <table className="calculation-table mb-3">
//             <tr>
//                 <th>Removal Fee</th>
//                 <td><input type="text" name="removal_fee" id="removal_fee" value={Number(removalCost)?.toFixed(2) ?? 0.00} onChange={(e) => setRemovalCost(Number(e.target.value))} /></td>
//             </tr>
//             <tr>
//                 <th>Subtotal</th>
//                 <td>$ {Number(formik.values.subtotal).toFixed(2)}</td>
//             </tr>
//             <tr>
//                 <th>Tax</th>
//                 <td><input type="text" name="tax" id="tax" value={Number(formik.values.tax).toFixed(2)} onChange={formik.handleChange} onBlur={formik.handleBlur} /></td>
//             </tr>
//             <tr>
//                 <th>Total</th>
//                 <td>$ {Number(formik.values.total).toFixed(2)}</td>
//             </tr>
//         </table>
//     </div>
// </div>

// <div className="row justify-content-end">
//     <div className="col-md-3 mt-3">
//         <label className="me-1 mb-1">Local Laws Compliance :</label><br />
//         <input
//             type="checkbox"
//             id="localLaws"
//             name="localLawsChecked"
//             checked={formik.values.localLawsChecked}
//             onChange={formik.handleChange}
//             onBlur={formik.handleBlur}
//         />
//         <span>{" "}I acknowledge adherence to local laws</span>

//     </div>
// </div>

// <button
//     type="submit"
//     className="btn btn-info mt-4 float-end"
//     disabled={formSubmitting || !formik.values.localLawsChecked}
// >
//     Submit Request
// </button>
